import { RootState } from 'store';
import { useSelector } from 'react-redux';

import { CARS_STATE } from '../../constants';

export const useSelectedCarEBoxLocation = () => {
  const selectedCarEBoxLocation = useSelector((state: RootState) => state[CARS_STATE].selectedEBoxLocation);
  return selectedCarEBoxLocation;
};